import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import type { ReactNode } from 'react';
import { ButtonStyleProps, ICON_SLOT } from './buttonStyle';

type Props = {
    side: 'start' | 'end';
    size: ButtonStyleProps['size'];
    children: ReactNode;
};

/**
 * A glyph beside a button's label, in {@link ICON_SLOT}. In the new design it is the kit `Button`'s inline start or
 * end icon, so the button takes 2px off that side; classic keeps its even padding. A component of its own so a
 * button with no glyph never reads the design.
 */
export default function ButtonIconSlot({ side, size, children }: Props) {
    const isNew = useIsNewDesign();
    return (
        <span data-icon={isNew ? `inline-${side}` : undefined} className={ICON_SLOT[size ?? 'medium']}>
            {children}
        </span>
    );
}
